import { alpaphat } from "../data/assetsData";
import { alpaphaImage } from "./image";
import React from "react";
function generateRandomEdges(nodes, connection) {
  const edgeList = [];
  const nodeIds = nodes.map((node) => node.id);

  for (let i = 0; i < nodeIds.length + 7; i++) {
    const from = getRandomNodeId(nodeIds);
    let to = getRandomNodeId(nodeIds);
    while (from === to) {
      to = getRandomNodeId(nodeIds);
    }

    const edge = {
      from: from,
      to: to,
      id: i,
      arrow: {
        to: connection === "Directed" ? true : false,
      },
    };

    edgeList.push(edge);
  }

  return edgeList;
}

function getRandomNodeId(nodeIds) {
  const randomIndex = Math.floor(Math.random() * nodeIds.length);
  return nodeIds[randomIndex];
}

export const GenerateRandom = (number = 5, setNodes, setEdges, connection) => {
  let nodeDemo = [];

  // const alpaphat = [...Array(26)].map((_, i) => String.fromCharCode(i + 65));
  for (let index = 0; index < number; index++) {
    nodeDemo.push({
      id: index + 1,
      image: alpaphaImage[index],
      shape: "circularImage",
      label: "",
      title: alpaphat[index],
      x: Math.random() * 500,
      y: Math.random() * 500,
    });
  }

  setNodes(nodeDemo);
  setEdges(generateRandomEdges(nodeDemo, connection));
};
